import { CustomAxios, getResponseData } from '../../redux/axios';
import {
  GetAuthConfigsResponse,
  GetSsoDetailsForTenantResponse,
  GetSsoExcludedUsersResponse,
  AuthConfigScopeType,
} from '@weave/schema-gen-ts/dist/schemas/auth-api/v3/auth.pb';

export const getSsoDetailsForTenant = (
  locationId: string
): Promise<GetSsoDetailsForTenantResponse> =>
  CustomAxios.get<GetSsoDetailsForTenantResponse>(
    '/auth-api/v3/sso/auth-tenant-details',
    {
      headers: { 'Location-Id': locationId },
    }
  ).then(getResponseData);

export const getAuthConfigs = (
  tenant: string,
  locationId: string
): Promise<GetAuthConfigsResponse> =>
  CustomAxios.get<GetAuthConfigsResponse>('/auth-api/v3/auth-configs', {
    params: { scopeType: AuthConfigScopeType.AUTHTENANT, scopeId: tenant },
    headers: { 'Location-Id': locationId },
  }).then(getResponseData);

export const getSsoExcludedUsers = (
  locationId: string
): Promise<GetSsoExcludedUsersResponse> =>
  CustomAxios.get<GetSsoExcludedUsersResponse>('/auth-api/v3/sso/excluded-users', {
    headers: { 'Location-Id': locationId },
  }).then(getResponseData);
